"use client";

import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { APP_NAME } from "../../config/constants";

type Props = {
  description?: string;
  children: React.ReactNode;
  title?: string;
};

const PageContainer = ({ title, description, children }: Props) => (
  <HelmetProvider>
    <div>
      <Helmet>
        <title>
          {title} - {APP_NAME}
        </title>
        <meta name="description" content={description} />
      </Helmet>
      {children}
    </div>
  </HelmetProvider>
);

export default PageContainer;
